import React from 'react';
import DetailSewaPage from '../DetailSewa';
import MetodePembayaranPage from '../MetodePembayaran';
import DetailPesananComponent from './DetailPesanan';

const KonfirmasiPesananPage = ({
  allVehicle,
  vehicleInput,
  setVehicleInput,
  orderData,
  setOrderData,
  rentalLocation,
  rentalLocationHandler,
  startRentDate,
  setStartRentDate,
  durationRent,
  setDurationRent,
  selectedCar,
  setSelectedCar,
  selectedAdditionalItem,
  setSelectedAdditionalItem,
  selectedPaymentType,
  setSelectedPaymentType,
  selectedLuggage,
  selectedPassengers,
  setSelectedLuggage,
  setSelectedPassengers,
  ktpImageLink,
  setKtpImageLink,
  passportImageLink,
  setPassportImageLink,
  nextPage,
  prevPage,
  paymentImageLink,
  setPaymentImageLink,
  allRentTime,
  setAllRentTime,
  allAreaCharter,
  setAllAreaCharter,
  isOrderConfirmation,
}) => {
  return (
    <div className="konfirmasi-pesanan-car-charter">
      <DetailSewaPage
        allVehicle={allVehicle}
        vehicleInput={vehicleInput}
        setVehicleInput={setVehicleInput}
        orderData={orderData}
        setOrderData={setOrderData}
        rentalLocation={rentalLocation}
        rentalLocationHandler={rentalLocationHandler}
        startRentDate={startRentDate}
        setStartRentDate={setStartRentDate}
        durationRent={durationRent}
        setDurationRent={setDurationRent}
        selectedCar={selectedCar}
        setSelectedCar={setSelectedCar}
        selectedAdditionalItem={selectedAdditionalItem}
        setSelectedAdditionalItem={setSelectedAdditionalItem}
        selectedPaymentType={selectedPaymentType}
        setSelectedPaymentType={setSelectedPaymentType}
        selectedLuggage={selectedLuggage}
        selectedPassengers={selectedPassengers}
        setSelectedLuggage={setSelectedLuggage}
        setSelectedPassengers={setSelectedPassengers}
        ktpImageLink={ktpImageLink}
        setKtpImageLink={setKtpImageLink}
        passportImageLink={passportImageLink}
        setPassportImageLink={setPassportImageLink}
        allRentTime={allRentTime}
        setAllRentTime={setAllRentTime}
        allAreaCharter={allAreaCharter}
        setAllAreaCharter={setAllAreaCharter}
        nextPage={nextPage}
        isOrderConfirmation={isOrderConfirmation}
      />

      <MetodePembayaranPage
        prevPage={prevPage}
        nextPage={nextPage}
        orderData={orderData}
        setOrderData={setOrderData}
        paymentImageLink={paymentImageLink}
        setPaymentImageLink={setPaymentImageLink}
        isOrderConfirmation={isOrderConfirmation}
      />

      <DetailPesananComponent
        prevPage={prevPage}
        selectedCar={selectedCar}
        orderData={orderData}
        allAreaCharter={allAreaCharter}
        allRentTime={allRentTime}
        selectedAdditionalItem={selectedAdditionalItem}
      />
    </div>
  );
};

export default KonfirmasiPesananPage;
